<template>
  <div class="page">
    <b-container
        v-if="true"    
        class=""
    >
      <b-row>
        <b-col
          sm="12"
          md="12"
        >
            <div
              v-if="techOutput && techOutput.wdQuery"
              class="mb-4"
            >
              <a
                :href="techOutput.wdQuery"
                target="_blank"
              >
                <h5>aktuelle Wikidata-Abfrage für die Daten auf Lost Generation Artists ...</h5>
              </a>
              
            </div>
            <div
              v-else
            >
              laden Link zur aktuellen Wikidata-Abfrage 
            </div>
            <h2>Weitere Wikidata-Abfragen</h2>
            <div
              class="mb-4"
            >
              <a
                href="https://query.wikidata.org/#%23%20Objekte%2C%20die%20mit%20dem%20Ereignis%20B%C3%BCcherverbrennung%201933%20verkn%C3%BCpft%20sind%0A%0ASELECT%20%3Fitem%20%3FitemLabel%20%3Fstatus%20%3FstatusLabel%0AWHERE%20%7B%0A%20%20VALUES%20%3Fevent%20%20%7B%0A%20%20%20%20wd%3AQ3927614%20%0A%20%20%7D%0A%0A%20%20%3Fitem%20wdt%3AP793%20%3Fevent.%0A%20%20%3Fitem%20wdt%3AP31%20%3Fstatus%0A%20%20SERVICE%20wikibase%3Alabel%20%7B%20bd%3AserviceParam%20wikibase%3Alanguage%20%22%5BAUTO_LANGUAGE%5D%2Cen%22.%20%7D%0A%7D%0AORDER%20BY%20%3FstatusLabel"
                target="_blank"
              >
                <h5>Welche Objekte sind mit dem Schlüsselereignis Bücherverbrennung 1933 verknüpft</h5>
              </a>
            </div>
            <div
              class="mb-4"
            >
              <a
                href="https://query.wikidata.org/#%23Die%201000%20am%20h%C3%A4ufigsten%20verkn%C3%BCpften%20Schl%C3%BCsselereignisse%0A%0ASELECT%20%3Fevent%20%3FeventLabel%20%28COUNT%28%3Fitem%29%20AS%20%3FitemCount%29%0AWHERE%0A%7B%0A%09%3Fitem%20wdt%3AP793%20%3Fevent.%0A%09SERVICE%20wikibase%3Alabel%20%7B%20bd%3AserviceParam%20wikibase%3Alanguage%20%22%5BAUTO_LANGUAGE%5D%2Cen%22.%20%7D%0A%7D%0AGROUP%20BY%20%3Fevent%20%3FeventLabel%0AORDER%20BY%20DESC%28%3FitemCount%29%0ALIMIT%201000"
                target="_blank"
              >
                <h5>Liste der 1.000 am häufigsten verknüpften Schlüsselereignisse </h5>
              </a>
            </div>
        </b-col>
        <b-col
          sm="12"
          md="4"
        >
          <!-- <h3
            class=""
          >
            Sidebar
          </h3>        
          <p>Inhalt Sidebar</p> -->
        </b-col>
      </b-row>
    </b-container>
    
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'techoutput',
  components: {
     
  },
  data () {
      return {
        localTechOutput: {}
      }
  },
  methods: {
    ...mapActions({
        
    })
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      techOutput: 'getTechOutput'
    })
  },
  created () {
    
  }
}
</script>
<style scoped>

</style>
